import { useState } from 'react';
import { useAuth } from '../../../components/AuthContext/context';

export const useDashboard = () => {
  const { currentUser, session, signOut, loading } = useAuth();

  const [isSideNavOpen, setIsSideNavOpen] = useState(true);

  const handleLogout = async () => await signOut();

  const handleHamburgerClick = () => {
    setIsSideNavOpen(isSideNavOpen => !isSideNavOpen);
  };

  return {
    isSideNavOpen,
    session,
    loading,
    currentUser,
    handleLogout,
    handleHamburgerClick,
  };
};
